<div class="alerts-list">
  <h2>
    customise
    <span class="add-alert-button" [routerLink]="['/admin/alerts/add']">create new item</span>
  </h2>

  <div class="customise-details">
    <p>you can customise Response Master - create or change:</p>
    <ul>
      <li>
        <span [ngbPopover]="alertContent" placement="top"
              triggers="mouseenter:mouseleave">
          an alert
          <ng-template #alertContent>
            Alert instructions
          </ng-template>
        </span>
      </li>
      <li>
        <span [ngbPopover]="alertContent" placement="top"
              triggers="mouseenter:mouseleave">
          a custom paragraph
          <ng-template #alertContent>
            Custom paragraph instructions
          </ng-template>
        </span>
      </li>
      <li>
        <span [ngbPopover]="alertContent" placement="top"
              triggers="mouseenter:mouseleave">
          a custom letter
          <ng-template #alertContent>
            Custom letter instructions
          </ng-template>
        </span>
      </li>
    </ul>
    <p>
      to <strong>create</strong> one of the above items, click 'create new item'.
      <br />
      to <strong>change</strong> an item, click its ID number below.
    </p>
  </div>

  <form #alertsFilterForm>
    <label class="form-group">
      <span>show</span>
      <span class="select-layer">
        <select class="app-select" name="show" [(ngModel)]="filter.show"
                (ngModelChange)="filterAlerts()">
          <option *ngFor="let showItem of filterShowList"
                  [ngValue]="showItem.id">
            {{showItem.name}}
          </option>
        </select>
      </span>
    </label>
    <label class="form-group">
      <span>created by</span>
      <span class="select-layer">
        <select class="app-select" name="created-by" [(ngModel)]="filter.createdBy"
                (ngModelChange)="filterByCreatedBy()">
          <option value="0">
            all users
          </option>
          <option [ngValue]="user.id" *ngFor="let user of usersList">
            {{user.firstName}} {{user.lastName}}
          </option>
        </select>
      </span>
    </label>
    <label class="form-group">
      <span>which are</span>
      <span class="select-layer">
        <select class="app-select" name="which-are" [(ngModel)]="filter.whichAre"
                (ngModelChange)="filterByWhichAre()">
          <option value="0">
            live
          </option>
          <option value="1">
            expired
          </option>
        </select>
      </span>
    </label>
    <label class="form-group">
      <span class="input-layer search">
        <input aria-label=""  type="text" [(ngModel)]="searchCriteria" (keyup)="filterAlerts()"
               name="search" class="app-input" placeholder="search alerts...">
        <img class="search-icon"
             [src]="constants.assetsPath + '/img/icons/search-grey.svg'" width="30" />
      </span>
    </label>
  </form>

  <div class="table-helper box-shadow">
    <table class="table-list">
      <thead>
        <tr>
          <td class="filter" [ngClass]="{'selected': alertsFilter === 'id'}"
              (click)="sortAlerts('id')">
            <span>id number</span>
          </td>
          <td class="filter" [ngClass]="{'selected': alertsFilter === 'type'}"
              (click)="sortAlerts('type')">
            <span>item type</span>
          </td>
          <td class="filter" [ngClass]="{'selected': alertsFilter === 'date'}"
              (click)="sortAlerts('date')">
            <span>date created</span>
          </td>
          <td class="filter" [ngClass]="{'selected': alertsFilter === 'name'}"
              (click)="sortAlerts('name')">
            <span>name</span>
          </td>
          <td class="filter" [ngClass]="{'selected': alertsFilter === 'instructions'}"
              (click)="sortAlerts('instructions')">
            <span>instructions</span>
          </td>
          <!-- <td class="filter" [ngClass]="{'selected': alertsFilter === 'displayed'}"
              (click)="sortAlerts('displayed')">
            <span>displayed</span>
          </td> -->
          <!-- <td class="filter" [ngClass]="{'selected': alertsFilter === 'applied'}"
              (click)="sortAlerts('applied')">
            <span>applied</span>
          </td> -->
          <td>
            <!--<span>Action</span>-->
          </td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let alert of alerts">
          <td class="link" routerLink="/admin/alerts/edit/{{alert.id}}"
              [innerHTML]="(alert.id < 10 ? '00' : alert.id < 100 ? '0' : '') + alert.id"></td>
          <td>{{alert.action === '0' ? 'alerts' : alert.action === '2' ? 'custom paragraphs' : 'custom letters'}}</td>
          <td>{{alert.createdOn}}</td>
          <td>{{alert.name}}</td>
          <td>{{alert.instructions}}</td>
          <!-- <td class="text-right">
            {{alert.timesDisplayed}}
          </td> -->
          <!-- <td class="text-right">
            {{alert.timesAccepted}}
          </td> -->
          <td class="link" (click)="open(alert.id)">
            delete
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <kendo-dialog *ngIf="opened"  (close)="close()">
    <kendo-dialog-titlebar>
        <div style="font-size: 18px; line-height: 1.3em;">
          <span class="k-icon k-i-warning k-icon-md"></span> delete alert?
        </div>
      </kendo-dialog-titlebar>
  <p style="margin: 30px; text-align: center;">
    Are you sure you want to delete this alert?
  </p>
  <kendo-dialog-actions>
    <button kendoButton  class="kendo-dialog-button" (click)="close()" role="button">No</button>
    <button kendoButton class="kendo-dialog-button" (click)="confirmDelete()">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>
</div>
